'use client'

import { useState, useEffect, useRef } from "react"
import { SearchFeedback } from "@/app/components/BookCarousel/SearcFeedback"
import styles from "./BookPrompt.module.css"

interface BookPromptProps {
  query: string
  searchId?: string
  isDetailsOpen?: boolean // Add this prop to handle hiding
}

export default function BookPrompt({ query, searchId, isDetailsOpen = false }: BookPromptProps) {
  const [feedbackGiven, setFeedbackGiven] = useState(false)
  const feedbackRef = useRef<HTMLDivElement>(null)

  // Observer to detect when SearchFeedback disappears
  useEffect(() => {
    if (!feedbackRef.current || !searchId) return

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          const feedbackElement = feedbackRef.current?.querySelector('[class*="container"]')
          if (!feedbackElement) {
            setFeedbackGiven(true)
          }
        }
      })
    })

    observer.observe(feedbackRef.current, {
      childList: true,
      subtree: true
    })

    return () => observer.disconnect()
  }, [searchId])

  // Build class names
  const promptClasses = [
    styles.prompt,
    isDetailsOpen && styles.bookDetailsOpen
  ].filter(Boolean).join(' ')

  const containerClasses = [
    styles.container,
    feedbackGiven && styles.animating
  ].filter(Boolean).join(' ')

  return (
    <div className={containerClasses}>
      <div className={promptClasses}>
        <svg 
          className={styles.icon}
          viewBox="0 0 20 20" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M15.3304 4H4.66345C3.92676 4 3.33008 4.59668 3.33008 5.33337V12.6669C3.33008 13.4036 3.92676 14.0003 4.66345 14.0003H7.72087L9.52558 15.805C9.78559 16.065 10.2076 16.065 10.4683 15.805L12.273 14.0003H15.3304C16.0671 14.0003 16.6638 13.4036 16.6638 12.6669V5.33337C16.6638 4.59668 16.0671 4 15.3304 4ZM15.3304 12.6669H11.997C11.8203 12.6669 11.6503 12.7369 11.5256 12.8622L9.99693 14.391L8.46822 12.8622C8.34355 12.7369 8.17355 12.6669 7.99687 12.6669H4.66345V5.33337H15.3304V12.6669Z" fill="currentColor"/>
          <path d="M9.95893 12.0002H10.0349L10.9496 10.2095L12.6637 9.33348L10.9496 8.45746L10.0349 6.66674H9.95893L9.0829 8.45746L7.33019 9.33348L9.0829 10.2095L9.95893 12.0002Z" fill="currentColor"/>
        </svg>
        <p className={styles.text}>{query}</p>
      </div>
      <div ref={feedbackRef} className={styles.feedbackWrapper}>
        {searchId && (
          <SearchFeedback 
            searchId={searchId}
            className={styles.searchFeedback}
          />
        )}
      </div>
    </div>
  )
}